import Icon from '../ui/Icon';
import { useT } from '../../i18n/index.jsx';
import type { Profile } from '../../types';

interface FloatingActionButtonProps {
  user: Profile | null | undefined;
  /** Wird benötigt, um nicht-verifizierte Firmen direkt ins Profil
   *  umzuleiten, statt sie in einen DB-RLS-Fehler laufen zu lassen. */
  onNav?: (tabId: string) => void;
  onOpenModal: (type: string, data?: unknown) => void;
}

/**
 * FloatingActionButton — FAB für Firma-Rolle zum schnellen Auftrag-Erstellen.
 *
 * Zeigt nur für die Firma-Rolle (Admins und Fahrer kriegen nichts).
 */
export function FloatingActionButton({ user, onNav, onOpenModal }: FloatingActionButtonProps) {
  const t = useT();
  if (!user || user.rolle === 'admin' || user.rolle === 'fahrer') return null;
  // Audit 089 #8 / Variante C / Sitzung Z (20.05.2026):
  // Bei nicht-verifizierter Firma würde Migration 083 den DB-Insert
  // ablehnen. Wir leiten den Klick stattdessen ins Profil um und
  // graunieren den Button leicht ein, damit der State erkennbar ist.
  const blocked = user.kycStatus !== 'approved';
  const action = function () {
    if (blocked) {
      if (onNav) onNav('profil');
      return;
    }
    onOpenModal('neuerAuftrag', null);
  };
  return (
    <button
      className="drpx-fab"
      onClick={action}
      title={blocked ? t('firmaAuftragGatePendingTitel') : t('quickNeuerAuftrag')}
      style={{
        background: blocked
          ? 'var(--surface2)'
          : 'linear-gradient(135deg,var(--accent),#15803d)',
        color: blocked ? 'var(--muted)' : '#fff',
        opacity: blocked ? 0.7 : 1,
      }}>
      <Icon name={blocked ? 'lock' : 'document-edit'} size={22} color={blocked ? undefined : '#fff'} />
    </button>
  );
}
